import api from "../../api/axios";

export const loginApi = (data) => {
  return api.post("/auth", data);
};

export const getApps = () => {
  return api.get("/apps");
};

//-----------------__App__Config__-----------------------------------

export const getAppConfigs = ({ page, limit, search, status }) => {
  return api.get("/app/configs", {
    params: {
      page,
      limit,
      search,
      status,
    },
  });
};

export const addAppConfig = (data) => {
  return api.post("/app/configs", data);
};

export const deleteAppConfig = (configId) => {
  return api.delete(`/app/configs/${configId}`);
};

export const updateAppConfig = (configId, data) => {
  return api.put(`/app/configs/${configId}`, data);
};
//-------------------------------bonus-------------------------------

export const getBonus = ({ page, limit, search, status }) => {
  return api.get("/bonus", {
    params: {
      page,
      limit,
      search,
      status,
    },
  });
};

export const addBonus = (data) => {
  return api.post("/bonus", data);
};

export const deleteBonus = (bonusId) => {
  return api.delete(`/bonus/${bonusId}`);
};

export const updateBonus = (bonusId, data) => {
  return api.put(`/bonus/${bonusId}`, data);
};
export const updateBonusStatus = (bonusId, data) => {
  return api.put(`/bonus/${bonusId}`, data);
};

export const crediBonusAmount = (user_id, date) => {
  return api.put(`/bonus/update/${user_id}`, date);
};

//--------------------------------Payout--------------------

export const getPayout = ({ page, limit, search }) => {
  return api.get("/payout", {
    params: {
      page,
      limit,
      search,
      //  status,
    },
  });
};

export const addPayout = (data) => {
  return api.post("/payout", data);
};

export const deletePayout = (payoutId) => {
  return api.delete(`/payout/${payoutId}`);
};

export const updatePayout = (payoutId, data) => {
  return api.put(`/payout/${payoutId}`, data);
};

export const updatePayoutStatus = (payoutId, data) => {
  return api.put(`/payout/${payoutId}`, data);
};
export const getAllPayoutTrans = ({ page, limit, search, status }) => {
  return api.get(`/payout-transactions`, {
    params: {
      page,
      limit,
      search,
      status,
    },
  });
};
export const getPayoutConfigs = () => {
  return api.get(`/payout-configs`);
};
export const addPayoutConfig = (data) => {
  return api.post(`/payout-configs`, data);
};
export const updatePayoutConfig = (id, data) => {
  return api.put(`/payout-configs/${id}`, data);
};
export const deletePayoutConfig = (id) => {
  return api.delete(`/payout-configs/${id}`);
};

//----------------------------Teams-------------------------------
export const getUsers = ({ page, limit, search, status }) => {
  return api.get("/members", {
    params: {
      page,
      limit,
      search,
      status,
    },
  });
};
export const userProfile = () => {
  return api.get("/profile");
};
export const updateProfile = (data) => {
  return api.put("/profile", data);
};
export const uploadAvatar = ({ userName, file }) => {
  const formData = new FormData();

  formData.append("file", file);

  return api.post("/upload", formData, {
    params: {
      folder: "avatar",
      bucket: "icons",
      name: userName,
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const changePassword = (data) => {
  return api.post("/change-password", data);
};
export const registerUser = (data) => {
  return api.post("/register", data);
};
export const updateUser = (userId, status) => {
  return api.put(`/members/${userId}/status`, { status: status });
};
export const blockUser = (userId) => {
  return api.put(`/members/${userId}/status`, { status: "blocked" });
};

export const unblockMember = (userId) => {
  return api.put(`/members/${userId}/status`, { status: "active" });
};
export const deleteUser = (userId) => {
  return api.delete(`/members/${userId}`);
};

export const loginMember = ({ email, password }) => {
  return api.post("/login", {
    email,
    password,
  });
};

//----------------------------Withdrawal-------------------------------
export const getPayoutOptions = () => {
  return api.get("/withdrawal");
};
export const updatePayoutOptions = (data) => {
  return api.put("/withdrawal", data);
};

export const updateWithdrawalStatus = ({ status }) => {
  return api.put("/withdrawal", {
    status: status,
  });
};

//-----------------------App User-------------------

export const getAppUsers = ({
  status,
  search,
  referrer,
  refer,
  orderBy,
  orderDirection,
  fromDate,
  toDate,
  page,
  limit,
}) => {
  return api.get("/users", {
    params: {
      status: status,
      search: search,
      referrer: referrer,
      refer: refer,
      orderBy: orderBy,
      orderDirection: orderDirection,
      fromDate: fromDate,
      toDate: toDate,
      page: page,
      limit: limit,
    },
  });
};

export const getAppUserDetails = (userId) => {
  return api.get(`/users/${userId}`);
};
export const updateLogoutUser = (userId) => {
  return api.put(`/users/${userId}`, { status: "inactive" });
};
export const updateLogInUser = (userId) => {
  return api.put(`/users/${userId}`, { status: "active" });
};

export const updateBlockUser = (userId) => {
  return api.put(`/users/${userId}`, { status: "blocked" });
};
export const updateUnBlockUser = (userId) => {
  return api.put(`/users/${userId}`, { status: "inactive" });
};

export const updateUserPayout = (userId, payload) => {
  return api.put(`/users/${userId}`, payload);
};

export const deleteSingleUser = (userId) => {
  return api.delete(`/deleteSingleUsers/${userId}`);
};

//----------------------- App Transactions-------------------
export const getAppTransactions = (payload) => {
  return api.get(`/transactions`, { params: payload });
};
export const getAppSources = () => {
  return api.get(`/sources`);
};

//------------------------Gateways----------------------
export const getGateways = () => {
  return api.get("/gateways");
};
export const addGateway = (data) => {
  return api.post("/gateways", data);
};
export const updateGatewayStatus = (id, status) => {
  return api.put("/gateways/" + id, { status: status });
};
export const deleteGateway = (id) => {
  return api.delete("/gateways/" + id);
};

export const getAllServices = (gateway) => {
  return api.get("/gateways/services", { params: { gateway: gateway } });
};
//----------------------Rule--------------------------
export const getRules = () => {
  return api.get("/rules");
};
export const addRule = (data) => {
  return api.post("/rules", data);
};
export const updateRule = (id, data) => {
  return api.put("/rules/" + id, data);
};
export const updateRuleSettings = (data) => {
  return api.put("/rules/settings", data);
};
export const deleteRule = (id) => {
  return api.delete("/rules/" + id);
};

//----------------------Gift Codes--------------------------

export const getGiftCodes = () => {
  return api.get("/giftcards");
};
export const getServiceGiftCodes = (id, { page, limit, status }) => {
  return api.get(`/inventory/${id}`, {
    params: {
      page,
      limit,
      status,
    },
  });
};

export const getInventory = () => {
  return api.get("/inventory");
};
export const addGiftCode = (data) => {
  return api.post("/giftcard", data);
};
export const deleteGiftCode = (id) => {
  return api.delete("/giftcard/" + id);
};
export const updateGiftCode = (id, data) => {
  return api.put("/giftcards/" + id, data);
};

//----------------------Images--------------------------
export const getImages = () => {
  return api.get("/media");
};
export const deleteImages = (id) => {
  return api.delete("/media/" + id);
};

export const uploadImage = ({ folder, bucket, name, file }) => {
  const formData = new FormData();

  formData.append("file", file);

  return api.post("/upload", formData, {
    params: {
      folder: folder,
      bucket: bucket,
      name: name,
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
//------------------Games----------------------------------------------
export const getGames = () => {
  return api.get("/games");
};
export const addGame = (payload) => {
  return api.post("/games",payload);
};
export const removeGame = (id) => {
  return api.delete(`/games/${id}`);
};
export const updateGame = (id,payload) => {
  return api.put(`/games/${id}`,payload);
};
export const updateGameStatus = (id,payload) => {
  return api.put(`/games/${id}`,payload);
};

//-------------------Notification----------------------------------------
export const getNotification = (app_id) => {
  return api.get(`/notification/scheduled?app_id=${app_id}`);
};
export const sendIntantNotification = (payload) => {
  return api.post("/notification/send", payload);
};
export const sendScheduleNotification = (payload) => {
  return api.post("/notification/schedule", payload);
};

//---------------------Analytics-----------------------------------------
export const getAnalytics = () => {
  return api.get("/analytics");
};
export const getBonusSource = () => {
  return api.get("/analytics/bonus/source");
};
export const getStats = (days) => {
  return api.get("/analytics/stats", {
    params: {
      days: days,
    },
  });
};
export const getBonusStat = (days, bonus) => {
  return api.get("/analytics/bonus", {
    params: {
      days: days,
      type: bonus,
    },
  });
};
//----------------System Config-----------------------

export const getSystemConfigs = (payload) => {
  return api.get("/configs", payload);
};

export const addSystemConfig = (data) => {
  return api.post("/configs", data);
};

export const deleteSystemConfig = (configId) => {
  return api.delete(`/configs/${configId}`);
};

export const updateSystemConfig = (configId, data) => {
  return api.put(`/configs/${configId}`, data);
};
